function importAll(r) {
   return r.keys().map(r);
}

export const allImagesNew = importAll(require.context('./', false, /\.(png|jpe?g|svg)$/));